export default "__VITE_ASSET__c0bf13d1__"